import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./assets/css/global-style.scss";
import "./assets/scss/main.scss";
// import Test from "./Test";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
